import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams, IWlTransactionApiListResponse } from '@/types';

export const wlTransactionList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IWlTransactionApiListResponse>> => {
    return axios.get('/api/wlTransaction/list', { ...config, params });
};

export const getWlTransactionLogfile = (id: number, createdAt: string, fileName?: string): Promise<AxiosResponse<{ success: boolean; file: string }>> => {
    if (fileName) {
        return axios.get('/api/wlTransaction/logfile', { params: { id, created_at: createdAt, fileName } });
    }
    return axios.get('/api/wlTransaction/logfile', { params: { id, created_at: createdAt } });
};
